module.exports = __webpack_public_path__ + "img/hawaii2016.fbdcadb4.jpg";